import { ApplicationState } from '../types';

export const parentSelector = (state: ApplicationState): ApplicationState => state;
